<template>
    <ElementLayout :parent="parent" :element="element">
        <v-text-field v-model="element.value" @change="fieldChanged" :label="element.title" :disabled="element.disabled" :hide-details="true" :single-line="false" />
    </ElementLayout>
</template>

<script>
import ElementLayout from '../ElementLayout' 

export default {
    data() {
        return {
            // value: null,
            // originalValue: null,
        }
    },

    components: {
        ElementLayout,
    },
    
    props: {
        element: Object,
        parent: Object,
    },

    computed: {

    },

    methods: {
        fieldChanged(newVal) {
            this.$emit('change', {value: newVal, previousValue: this.originalValue})
            this.originalValue = newVal
        },
    },

    created() {
        
    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// TextControl.vue?62d247fa